import { render, staticRenderFns } from "./WorkspaceInvitationPage.vue?vue&type=template&id=0ebdc1d3&scoped=true"
import script from "./WorkspaceInvitationPage.vue?vue&type=script&lang=ts"
export * from "./WorkspaceInvitationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebdc1d3",
  null
  
)

export default component.exports